import { IExportColumnModel } from "../../../../shared/models";

export const ProtectedOperationsColumnList: IExportColumnModel[] = [
]